import styled from 'styled-components';
import COLORS from '@mlb/react-patterns/style/universal.color';

const {

    mlbBlack,
    mlbGrey5,
    mlbGrey2
} = COLORS;

export const InnerWrapper = styled.div`
    color: var(--gameday-primary-font-color);
    .responsive-pitch-fx-data-item {
        font-size: 18px;
        line-height: 18px;
        font-weight: 700;
        margin-bottom:8px;

        .label {
            width: 110px;
            color: var(--gameday-secondary-font-color);
            display: inline-block;
        }

        .data-point {
            display: inline-block;
            color: var(--gameday-primary-font-color);
        }
        &:last-child {
          margin-bottom: 0;
        }
        &:first-child {
            margin-top: 0;
            margin-bottom: 16px;
            span {
              &.label {
                width: auto;
                color: var(--gameday-primary-font-color);
              }
              &.data-point {
                &::before {
                  content: "|";
                  margin: 0 5px;
                  color: var(--gameday-divider-color);
                  font-style: normal;
                  font-weight: 700;
                  font-size: 18px;
                  line-height: 18px
                  width: 2px;
                }
              }
            }  
        }
    }
`;
